/**
 * Componente para exibir quando a análise não está disponível
 * (arquivo ainda em processamento)
 */

import React from 'react'
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography
} from '@mui/material'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import RefreshIcon from '@mui/icons-material/Refresh'

type Props = {
  title: string
  onRetry?: () => void
}

export default function AnalysisNotAvailableCard({ title, onRetry }: Props) {
  return (
    <Card elevation={0} sx={{ border: '1px solid #e0e0e0', bgcolor: '#fafafa' }}>
      <CardContent sx={{ textAlign: 'center', py: 5 }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            bgcolor: '#fff3e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2
          }}
        >
          <HourglassEmptyIcon sx={{ fontSize: 36, color: '#f57c00' }} />
        </Box>
        
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#333', mb: 1 }}>
          {title}
        </Typography>
        
        <Typography variant="body2" sx={{ color: '#666', mb: 3, maxWidth: 400, mx: 'auto' }}>
          Esta análise ainda não está disponível. O arquivo está sendo processado em segundo plano. 
          Por favor, aguarde alguns minutos e tente novamente.
        </Typography>

        {onRetry && (
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
            sx={{ textTransform: 'none' }}
          >
            Verificar novamente
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
